<template>
  <article>
    <div class="mt-20 reset-number-style">
      <group v-if="showCard">
        <cell class="cou-cell">
          <p slot="after-title"><span class="cou-label">业务人员：</span>{{requestor}}</p>
          <p slot="after-title"><span class="cou-label">礼品卡号：</span>{{gift_card_no}}</p>
          <p slot="after-title"><span class="cou-label">可用余额：</span>{{gift_card_balance | formatePrice}}元</p>
          <p slot="after-title"><span class="cou-label">退回金额：</span>{{retreat_amount | formatePrice}}元</p>
          <p slot="after-title"><span class="cou-label">关联客户：</span>{{{name: to_customer_name, mobile: to_customer_mobile} | isCustomer}}</p>
          <p slot="after-title"><span class="cou-label">关联车牌：</span>{{to_customer_plate_number || '--'}}</p>
          <p slot="after-title"><span class="cou-label">提交时间：</span>{{create_at}}</p>
          <div slot="after-title" class="last-info">
            <p class="cou-label">退回原因：</p>
            <p class="coupon-reason">{{reason}}</p>
          </div>
        </cell>
        <cell>
          <div slot="value">
            <a class="btn-pass-no" @click.stop="onCheck('reject', retreat_request_id)" v-if="status && +status.key === 2">审核不通过</a>&nbsp;&nbsp;
            <a class="btn-pass" @click.stop="onCheck('pass', retreat_request_id)" v-if="status && +status.key === 2">审核通过</a>
            <a class="btn-check-ok" v-else>{{status && status.value}}</a>
          </div>
        </cell>
      </group>
      <div class="no-card-message" v-if="!showCard">
        {{noCardMsg}}
      </div>
    </div>
  </article>
</template>
<script>
import { Cell, Group } from '@lx-frontend/cvux'

export default {
  components: {
    Cell,
    Group
  },
  data() {
    return {
      retreat_request_id: '',
      requestor: '',
      to_customer_name: '',
      to_customer_mobile: '',
      to_customer_plate_number: '',
      create_at: '',
      gift_card_no: '',
      gift_card_title: '',
      gift_card_face_value: '',
      gift_card_balance: '',
      retreat_amount: '',
      reason: '',
      is_expired: '',
      status: {},
      retreatId: '',
      showCard: true,
      noCardMsg: ''
    }
  },
  created() {
    const param = this.$route.params.id
    this.retreatId = +param
    this.getData()
  },
  filters: {
    isCustomer({ name, mobile }) {
      return name ? `${name}（${mobile}）` : mobile
    },
    formatePrice(price) {
      return (price / 100).toFixed(2)
    }
  },
  methods: {
    getData() {
      this.switchLoading({ status: true, text: '加载中...' })
      this.$rest.gift.getRetreatCardById(null, this.retreatId).then(res => {
        if (res.code === 0) {
          let data = res.data
          for (let key of Object.keys(data)) {
            this[key] = data[key]
          }
        } else {
          this.showToast(res.message)
          this.showCard = false
          this.noCardMsg = res.message
        }
        this.switchLoading({ status: false })
      })
    },
    // 审核
    onCheck(action, id) {
      if (!this.isChecking) {
        this.isChecking = true
        this.$rest.gift.retreatCheck({
          retreat_request_id: id
        }, `${action}`).then(res => {
          if (res.code === 0) {
            this.showToast('审核成功！')
            this.getData()
          } else {
            this.showToast(res.message)
          }
          this.isChecking = false
        })
      }
    }
  }
}

</script>
<style scoped lang="less">
@import "../../stylesheets/modules/coupon/record";

.reset-number-style {

  .no-card-message {
    margin-top: 15%;
    font-size: 16px;
    color: #aaa;
    text-align: center;
  }
}
</style>
